import React, { useState, useEffect } from 'react';
import { validateStep1 } from '../lib/onboardingSchema';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useGeoLocation } from '../hooks/useGeoLocation';

export default function BusinessInfoStep({ data, onChange, onNext }) {
  const isValid = validateStep1(data);
  const geo = useGeoLocation();

  useEffect(() => {
    if (!geo.loading && geo.city && !data.location) {
      onChange('location', `${geo.city}, ${geo.state}`);
    }
  }, [geo, data.location, onChange]);

  return (
    <div className="space-y-6 animate-fadeIn">
      <div className="mb-8">
        <h3 className="text-xl text-brand-deep mb-2">Let’s start with a handshake</h3>
        <p className="text-gray-600">Enter your business details to lock in your spot in the Territory.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="label-text">Business Name *</label>
          <input 
            type="text" 
            className="input-field" 
            placeholder="e.g. Acme Plumbing"
            value={data.businessName}
            onChange={(e) => onChange('businessName', e.target.value)}
            style={{ color: '#101F1F', backgroundColor: '#FFFFFF', WebkitTextFillColor: '#101F1F' }}
          />
        </div>
        <div>
          <label className="label-text">Contact Name *</label>
          <input 
            type="text" 
            className="input-field" 
            placeholder="Main point of contact"
            value={data.contactName}
            onChange={(e) => onChange('contactName', e.target.value)}
            style={{ color: '#101F1F', backgroundColor: '#FFFFFF', WebkitTextFillColor: '#101F1F' }}
          />
        </div>
        <div>
          <label className="label-text">Email Address *</label>
          <input 
            type="email" 
            className="input-field" 
            placeholder="admin@example.com"
            value={data.email}
            onChange={(e) => onChange('email', e.target.value)}
            style={{ color: '#101F1F', backgroundColor: '#FFFFFF', WebkitTextFillColor: '#101F1F' }}
          />
        </div>
        <div>
          <label className="label-text">Phone Number</label>
          <input 
            type="tel" 
            className="input-field" 
            placeholder="(555) 123-4567"
            value={data.phone}
            onChange={(e) => onChange('phone', e.target.value)}
            style={{ color: '#101F1F', backgroundColor: '#FFFFFF', WebkitTextFillColor: '#101F1F' }}
          />
        </div>
        <div className="md:col-span-2">
          <label className="label-text">City / State</label>
          <input 
            type="text" 
            className="input-field" 
            placeholder={geo.loading ? 'Detecting location...' : 'e.g. Austin, TX'}
            value={data.location}
            onChange={(e) => onChange('location', e.target.value)}
            style={{ color: '#101F1F', backgroundColor: '#FFFFFF', WebkitTextFillColor: '#101F1F' }}
          />
        </div>
      </div>

      <div className="pt-6 mt-6 border-t border-gray-100 flex justify-end">
        <button 
          onClick={onNext} 
          disabled={!isValid}
          className="btn-primary"
        >
          Lock in Profile <SafeIcon icon={FiIcons.FiArrowRight} />
        </button>
      </div>
    </div>
  );
}